import React from 'react'
import {
   AIPoweredEngagementToolsIcon,
   AIPoweredGamingIcon,
   ContinuousSupportIcon,
   CustomSocialNetworksIcon,
   ScalableSolutionsIcon,
   SeamlessIntegrationIcon,
   SecureBlockchainGamingIcon,
   SecurePrivateNetworkingIcon,
} from '@/svgs'
import { WhyChooseOur } from '@/components'

const featureCards = [
   {
      title: 'Custom Social Networks',
      subtitle: 'Tailored Platforms for User Interaction',
      description:
         'We build custom social networking apps, including community platforms, live-streaming apps, and niche-based dating solutions, ensuring seamless connectivity.',
      icon: <CustomSocialNetworksIcon />,
   },
   {
      title: 'AI-Powered Engagement Tools',
      subtitle: 'Smart Recommendations and Analytics',
      description:
         'We implement AI-driven analytics tools that track user behavior, engagement trends, and sentiment analysis, helping businesses improve retention strategies.',
      icon: <AIPoweredEngagementToolsIcon />,
   },
   {
      title: 'Secure & Private Networking',
      subtitle: 'End-to-End Encryption & Fraud Detection',
      description:
         'We ensure GDPR, CCPA, and data protection standards, integrating AI-powered identity verification and secure payment processing.',
      icon: <SecurePrivateNetworkingIcon />,
   },
   {
      title: 'Seamless System Integration',
      subtitle: 'Social Media, CRM & Payment Gateways',
      description:
         'We develop social and dating platforms that integrate with social logins, AI chatbots, CRM systems, and third-party APIs, ensuring enhanced functionality.',
      icon: <SeamlessIntegrationIcon />,
   },
   {
      title: 'Scalable Cloud-Based Solutions',
      subtitle: 'Optimized Performance and Growth',
      description:
         'Our cloud-powered social solutions support real-time data synchronization, multi-user interactions, and high-speed performance, enabling scalability for growing platforms.',
      icon: <ScalableSolutionsIcon />,
   },
   {
      title: 'Continuous Support & Upgrades',
      subtitle: 'Feature Enhancements and Maintenance',
      description:
         'We offer 24/7 technical assistance, security patches, and feature updates to guarantee that social and dating platforms stay competitive and ahead of the times.',
      icon: <ContinuousSupportIcon />,
   },
]

function SocialWhyChoose() {
   return (
      <>
         <WhyChooseOur
         classCustom='fintech_custom_why_choose'
            title={
               'Why Choose Our Gaming & Sports Software Development Services?'
            }
            desc={
               'We develop secure, scalable, and innovative gaming and sports solutions that enhance user engagement, optimize performance, and revolutionize game development. Here’s why businesses choose Benzatine:'
            }
            cardData={featureCards}
            otherUi={true}
         />
      </>
   )
}

export default SocialWhyChoose
